export const TRANSLATIONS = {
    en: {
        nav: {
            home: 'Home',
            bestOffers: 'Best Offers',
            destinations: 'Destinations',
            services: 'Our Services',
            faq: 'FAQ',
            contact: 'Contact Us',
            about: 'About Us',
            blog: 'Blog (Soon)',
            signup: 'Sign up'
        },
        hero: {
            headline: "Don't just imagine it, \n make it happen. Travel",
            tabs: { flights: 'Flight', hotel: 'Hotel', trains: 'Trains' },
            wizard: {
                step1_flight: "Where do you want to fly?",
                step1_train: "Where do you want to go by train?",
                step1_hotel: "Where do you want to stay?",
                step2: "When are you planning to go?",
                step3: "Who is traveling with you?",
                from: "From",
                to: "To",
                location: "Destination",
                currentLocation: "Current Location (Kuwait)",
                next: "Next",
                back: "Back",
                book: "Book via WhatsApp",
                adults: "Adults",
                children: "Children",
                class: "Class",
                classes: { economy: "Economy", business: "Business", first: "First" },
                tripDatesLabel: "Trip Dates",
                tripDatesPlaceholder: "Select your travel dates",
                dates: "Dates",
                weekend: "Weekend",
                month: "Month",
                room: "Room",
                addRoom: "Add Room",
                remove: "Remove",
                adultsAge: ">17 years",
                childrenAge: "≤17 years"
            }
        },
        social: {
            rating: '4.8/5 Rating'
        },
        destinations: {
            title: 'Adventure Begins Here',
            subtitle: 'Choose from thousands of Organized Adventures',
            cta: 'Check out deals'
        },
        activities: {
            title: 'Prominent Activities'
        },
        payment: {
            title: 'Travel and enjoy flexible payment options'
        },
        packages: {
            eyebrow: 'Exclusive Offers',
            title: 'Trending Destinations',
            viewDeal: 'Reserve Now',
            priceLabel: 'Total Price',
            curr: 'KWD'
        },
        packageIncludes: {
            flight_ticket: 'Flight Ticket',
            hotel_stay: 'Hotel Stay',
            airport_transfer: 'Airport Transfer',
            breakfast: 'Breakfast',
            lunch: 'Lunch',
            dinner: 'Dinner',
            guided_tour: 'Guided Tour',
            travel_insurance: 'Travel Insurance',
            visa_assistance: 'Visa Assistance'
        },
        contact: {
            eyebrow: 'Do you need our help?',
            title: 'Contact us for help\nor information',
            subtitle: 'We provide through the button below',
            placeholder: 'Enter your email',
            submit: 'Submit'
        },
        footer: {
            brandDesc: 'Relationships where we know our customers so well that we can suggest and deliver Total Travel Solutions for their needs.',
            titles: { pages: 'Important Pages', services: 'Our Services', legal: 'Legal', support: 'Support' },
            links: {
                pages: [
                    { label: 'Home', href: '/' },
                    { label: 'Best Offers', href: '/packages' },
                    { label: 'Destinations', href: '/destinations' },
                    { label: 'Our Services', href: '/services' }
                ],
                services: [
                    { label: 'Flight Booking', href: '/flight-booking' },
                    { label: 'Hotel Reservations', href: '/hotel-booking' },
                    { label: 'Car Rental Service', href: '/car-rental' },
                    { label: 'Meet & Greet Service', href: '/delegation-reception' },
                    { label: 'Tourist Visa Issuance', href: '/visa-services' }
                ],
                legal: [
                    { label: 'Terms & Conditions', href: '/en/terms' },
                    { label: 'Privacy Policy', href: '/en/privacy' }
                ],
                support: [
                    { label: 'FAQ', href: '/faq' },
                    { label: 'Contact Us', href: '/contact' }
                ]
            },
            rights: '©2026 COMO All rights reserved'
        },
        testimonials: {
            eyebrow: 'Testimonials',
            title: 'What our travelers say'
        },
        details: {
            back: 'Back to Home',
            heroTitle: 'Best Maldives Travel Offers 2025 – 2026',
            heroSub: 'Best Maldives Travel Offers 2025 – 2026',
            sectionTitle: 'Available Packages in Maldives',
            articleTitle: 'Why Maldives is the Paradise on Earth',
            date: '12 March, 2024',
            author: 'Editor\'s Choice',
            p1: 'The Maldives, a tropical haven of immaculate beaches, turquoise lagoons, and swaying palm trees, is often described as the last paradise on earth. But what makes this archipelago so uniquely captivating for travelers from around the globe?',
            h1: 'Unmatched Luxury and Privacy',
            p2: 'Nowhere else in the world offers the concept of "one island, one resort" quite like the Maldives. This unique geography ensures an level of privacy and exclusivity that is hard to find elsewhere. Whether you choose an overwater villa with direct ocean access or a beach villa surrounded by lush vegetation, you are guaranteed a sanctuary of peace.',
            h2: 'A Marine Wonderland',
            p3: 'Beneath the shimmering surface lies a vibrant world of coral reefs teeming with life. From manta rays in Hanifaru Bay to gentle whale sharks in South Ari Atoll, the Maldives offers some of the best diving and snorkeling experiences on the planet. The visibility is crystal clear, often exceeding 30 meters, making it a photographer\'s dream.',
            quote: '"The Maldives is not just a destination; it\'s an emotion. It\'s the feeling of warm sand between your toes and the sound of gentle waves lulling you to sleep."'
        }
    }
    ,
    ar: {
        nav: {
            home: 'الرئيسية',
            bestOffers: 'أفضل العروض',
            destinations: 'الوجهات',
            services: 'خدماتنا',
            faq: 'الأسئلة الشائعة',
            contact: 'إتصل بنا',
            about: 'من نحن',
            blog: 'المدونة (قريباً)',
            signup: 'تسجيل الدخول'
        },
        hero: {
            headline: "احجز بثقة… سافر براحة",
            tabs: { flights: 'طيران', hotel: 'فنادق', trains: 'قطارات' },
            wizard: {
                step1_flight: "إلى أين تريد السفر؟",
                step1_train: "إلى أين تريد السفر بالقطار؟",
                step1_hotel: "أين تريد الإقامة؟",
                step2: "متى تخطط للسفر؟",
                step3: "من يسافر معك؟",
                from: "من",
                to: "إلى",
                location: "الوجهة",
                currentLocation: "الموقع الحالي (الكويت)",
                next: "التالي",
                back: "رجوع",
                book: "احجز عبر واتساب",
                adults: "البالغين",
                children: "الأطفال",
                class: "الدرجة",
                classes: { economy: "اقتصادية", business: "رجال الأعمال", first: "أولى" },
                tripDatesLabel: "تواريخ الرحلة",
                tripDatesPlaceholder: "اختر تواريخ سفرك",
                dates: "تواريخ",
                weekend: "نهاية الأسبوع",
                month: "شهر",
                room: "غرفة",
                addRoom: "أضف غرفة",
                remove: "حذف",
                adultsAge: ">17 سنة",
                childrenAge: "≤17 سنة"
            }
        },
        social: {
            rating: '4.8/5 تقييم'
        },
        destinations: {
            title: 'المغامرة تبدأ هنا',
            subtitle: 'اختر من بين آلاف المغامرات المنظمة',
            cta: 'تصفح العروض'
        },
        activities: {
            title: 'أبرز الأنشطة'
        },
        payment: {
            title: 'سافر واستمتع بخيارات دفع مرنة'
        },
        packages: {
            eyebrow: 'عروض حصرية',
            title: 'وجهات مميزة',
            viewDeal: 'احجز الآن',
            priceLabel: 'بسعر يبدأ من',
            curr: 'د.ك'
        },
        packageIncludes: {
            flight_ticket: 'تذكرة طيران',
            hotel_stay: 'إقامة فندقية',
            airport_transfer: 'نقل من المطار',
            breakfast: 'إفطار',
            lunch: 'غداء',
            dinner: 'عشاء',
            guided_tour: 'جولة سياحية',
            travel_insurance: 'تأمين سفر',
            visa_assistance: 'مساعدة التأشيرة'
        },
        contact: {
            eyebrow: 'هل تحتاج مساعدة؟',
            title: 'تواصل معنا للمساعدة\nأو المعلومات',
            subtitle: 'نحن نقدم المساعدة عبر الزر أدناه',
            placeholder: 'أدخل بريدك الإلكتروني',
            submit: 'إرسال'
        },
        footer: {
            brandDesc: 'علاقات حيث نعرف عملاءنا جيداً لدرجة أننا نستطيع اقتراح وتقديم حلول سفر كاملة لاحتياجاتهم.',
            titles: { pages: 'أهم الصفحات', services: 'خدماتنا', legal: 'قانوني', support: 'الدعم' },
            links: {
                pages: [
                    { label: 'الرئيسية', href: '/' },
                    { label: 'أفضل العروض', href: '/عروض-السفر' },
                    { label: 'الوجهات', href: '/الوجهات' },
                    { label: 'خدماتنا', href: '/خدماتنا' }
                ],
                services: [
                    { label: 'حجز تذاكر الطيران', href: '/حجز-تذاكر-الطيران' },
                    { label: 'حجوزات الفنادق', href: '/حجوزات-الفنادق' },
                    { label: 'خدمة تأجير السيارات', href: '/تأجير-السيارات' },
                    { label: 'خدمة استقبال الوفود', href: '/استقبال-الوفود' },
                    { label: 'إصدار التأشيرات السياحية', href: '/التأشيرات' }
                ],
                legal: [
                    { label: 'الشروط و الأحكام', href: '/الشروط-والأحكام' },
                    { label: 'سياسة الخصوصية', href: '/سياسة-الخصوصية' }
                ],
                support: [
                    { label: 'الأسئلة الشائعة', href: '/الأسئلة-الشائعة' },
                    { label: 'إتصل بنا', href: '/اتصل-بنا' }
                ]
            },
            rights: '©2026 COMO جميع الحقوق محفوظة'
        },
        testimonials: {
            eyebrow: 'آراء العملاء',
            title: 'ماذا يقول مسافرونا'
        },
        details: {
            back: 'العودة للرئيسية',
            heroTitle: 'أفضل عروض السفر للمالديف 2025 – 2026',
            heroSub: 'أفضل عروض السفر للمالديف 2025 – 2026',
            sectionTitle: 'الباقات المتاحة في المالديف',
            articleTitle: 'لماذا المالديف هي الجنة على الأرض',
            date: '12 مارس، 2024',
            author: 'خيار المحرر',
            p1: 'المالديف، ملاذ استوائي من الشواطئ النقية، والبحيرات الفيروزية، وأشجار النخيل المتمايلة، غالباً ما توصف بأنها آخر جنة على الأرض. ولكن ما الذي يجعل هذا الأرخبيل آسراً بشكل فريد للمسافرين من جميع أنحاء العالم؟',
            h1: 'رفاهية وخصوصية لا مثيل لها',
            p2: 'لا يوجد مكان آخر في العالم يقدم مفهوم "جزيرة واحدة، منتجع واحد" تماماً مثل المالديف. تضمن هذه الجغرافيا الفريدة مستوى من الخصوصية والحصرية يصعب العثور عليه في مكان آخر. سواء اخترت فيلا فوق الماء مع وصول مباشر للمحيط أو فيلا شاطئية محاطة بالنباتات المورقة، فأنت مضمون بملاذ من السلام.',
            h2: 'عجائب بحرية',
            p3: 'تحت السطح المتلألئ يكمن عالم نابض بالحياة من الشعاب المرجانية التي تعج بالحياة. من أسماك شيطان البحر في خليج هانيفارو إلى أسماك القرش الحوت اللطيفة في جنوب أري أتول، تقدم المالديف بعضاً من أفضل تجارب الغوص والغطس على هذا الكوكب. الرؤية واضحة وضوح الشمس، غالباً ما تتجاوز 30 متراً، مما يجعلها حلماً للمصورين.',
            quote: '"المالديف ليست مجرد وجهة؛ إنها شعور. إنها شعور الرمل الدافئ بين أصابع قدميك وصوت الأمواج اللطيفة التي تهدئك للنوم."'
        }
    }
};
